import axios from "axios";

const byodLogin = axios.create({
  baseURL: process.env.REACT_APP_LOGINURL,
  headers: {
    "Content-Type": "application/json",
  },
});
byodLogin.interceptors.request.use(
  (config) => {
    config.headers = {
      ...config.headers,
    };
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

const request = {
  get: (url, params) =>
    byodLogin
      .get(url, { params })
      .then((res) => res.data)
      .catch((err) => Promise.reject(err.response.data)),
};

//* 1.Get Provider Uploaded Docs By Id
export const byodLoginCall = (params) => request.get("login", params);
